import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { MatPaginator } from '@angular/material/paginator';
import { MessageFiltersComponent } from '../message-filters/message-filters.component';

@Component({
	selector: 'app-messages-list',
	templateUrl: './messages-list.component.html',
	styleUrls: ['./messages-list.component.scss'],
	providers: [MessageFiltersComponent],
})
export class MessagesListComponent implements OnInit, AfterViewInit {
	constructor(public service: MessageService) {}
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('filtersComponentRef', { static: true }) filtersComponent: any;

	async ngOnInit(): Promise<void> {
		this.service.loggedUserId = (await this.service.getLoggedUser()).id;
	}

	ngAfterViewInit() {
		this.service.paginator = this.paginator;
		this.translateMatPaginator(this.paginator);
	}

	private translateMatPaginator(paginator: MatPaginator) {
		paginator._intl.firstPageLabel = 'Pierwsza strona';
		paginator._intl.itemsPerPageLabel = 'Produkty na stronę';
		paginator._intl.lastPageLabel = 'Ostatnia strona';
		paginator._intl.nextPageLabel = 'Następna strona';
		paginator._intl.previousPageLabel = 'Poprzednia strona';
	}
}
